// extracted by mini-css-extract-plugin
module.exports = {"container":"_3v-VH1EBcKBDlKvyx57fMe"};